import { formatTitle, mapLocationStreetLabelText } from '@utils/dxb-utils';
import { AppMetaData }                             from '@core/constants/app-meta-data';
import { OpenGraphMedia }                          from 'next-seo/lib/types';
import { S3_PROPERTY_BUCKET_URL }                  from '@utils/network-utils';


export const getPropertyDetailsSeoData = (propertyDetailsData) => {

    const beds = `${propertyDetailsData?.details?.bed_rooms} ${formatTitle(propertyDetailsData?.details?.bed_rooms, 'Bed')}`;
    const baths = `${propertyDetailsData?.details.bath_rooms} ${formatTitle(propertyDetailsData?.details?.bath_rooms, 'Bathroom')}`;
    const guests = `${propertyDetailsData?.details.max_occupancy} ${formatTitle(propertyDetailsData?.details?.max_occupancy, 'Guest')}`
    const address = mapLocationStreetLabelText(propertyDetailsData?.location?.address) || '_';
    const seoDescription = propertyDetailsData?.description?.substring(0, 150) || '_';
    const seoTitle = ` ${beds} | ${baths} | ${guests} | Available In ${address}`;

    const propImages = propertyDetailsData?.images?.filter((img) => img.type === 'image' && img)
    const seoImage: OpenGraphMedia[] = [];

    propImages?.forEach((img) => {
        // img.src
        seoImage.push({
            url: `${S3_PROPERTY_BUCKET_URL}/${img.src}`,
            alt: img.alt,
        })
    });

    return {
        title: seoTitle,
        description: seoDescription,
        images: seoImage,
        locale: AppMetaData.APP_LOCALE,
        siteName: AppMetaData.APP_NAME,
    }

}
